$(document).ready(function () {

    window.addEventListener("resize", updateView);

    function updateView() {
        if (document.documentElement.clientWidth <= 767) {
            $("#loginCard-nz").removeAttr("class")
            $("#loginCard-nz").addClass("ui aligned basic segment");

            $("#orDivider-nz").removeAttr("class")
            $("#orDivider-nz").addClass("ui horizontal divider");
        } else {
            $("#loginCard-nz").removeAttr("class")
            $("#loginCard-nz").addClass("ui two column very relaxed stackable grid");

            $("#orDivider-nz").removeAttr("class")
            $("#orDivider-nz").addClass("ui vertical divider");
        }
    }
});
